import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { STOCK_LOCATION, StockLocationKindValues, STOCK_LOCATION_KIND_LABELS, } from '../types/stock-location.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for StockLocation entity.
 * Stored in 'org/{orgId}/stock-location'.
 *
 * Default data source is PostgresRest — ledger FKs (fase D) require the catalog
 * in the same database (ADR 0003 §D7; request 0094).
 */
export const stockLocationDescriptor = {
    name: STOCK_LOCATION,
    label: 'Local de Estoque',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/stock-location',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Stock accounting location (balance key)',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique stock location identifier',
        },
        {
            name: 'code',
            example: 30,
            label: 'Código',
            type: 'number',
            required: true,
            unique: true,
            autoNumber: true,
            description: 'Numeric location code (master-data identifier; non-negative, capped at MAX_CODE_SMALL)',
        },
        {
            name: 'description',
            example: 'Expedição',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Stock location description',
        },
        {
            name: 'distributionCenterId',
            label: 'Centro de distribuição',
            type: 'string',
            required: false,
            description: 'Optional FK to DistributionCenter (any kind may omit it)',
        },
        {
            name: 'kind',
            example: 'physical',
            label: 'Tipo',
            type: 'enum',
            required: true,
            enumValues: [...StockLocationKindValues],
            enumLabels: STOCK_LOCATION_KIND_LABELS,
            description: 'physical | in-transit | third-party | virtual',
        },
        {
            name: 'countsAsAvailable',
            example: true,
            label: 'Conta como disponível',
            type: 'boolean',
            required: true,
            description: 'Whether balance at this location counts as available stock',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        ...AUDIT_FOREIGN_KEYS,
        {
            fieldName: 'distributionCenterId',
            targetEntity: 'DistributionCenter',
            relationship: 'many-to-one',
            description: 'Distribution center that hosts this location',
            displayField: 'name',
        },
    ],
};
//# sourceMappingURL=stock-location.descriptor.js.map